<app-loader></app-loader>

<div class="register-shell">
  <div class="register-card shadow-sm">
    <div class="register-panel register-panel-info">
      <div class="brand-row">
        <div class="brand-badge">
          <i class="fa-solid fa-paw"></i>
        </div>
        <div class="brand-name">iGuau</div>
      </div>

      <div class="image-composition">
        <div class="floating-dot floating-dot-top"><i class="fa-solid fa-paw"></i></div>
        <div class="floating-dot floating-dot-bottom"><i class="fa-solid fa-heart"></i></div>

        <img
          [src]="backgroundImage"
          alt="Mascota iGuau"
          class="img-main"
        >
        <img
          [src]="global.urlServer + 'img/hombre-register.png'"
          alt="Comunidad iGuau"
          class="img-secondary"
        >
      </div>

      <div class="info-copy">
        <div class="eyebrow">COMUNIDAD IGUAU</div>
        <h1>Donde las mascotas<br>hacen amigos</h1>
        <p>
          Únete a <strong>iGuau</strong> y crea un perfil para ti y tus mascotas.
          Descubre otros compañeros peludos, comparte momentos especiales y
          conecta con personas que viven su misma pasión por los animales.
        </p>
      </div>

      <div class="benefit-grid">
        <div class="benefit-card">
          <div class="benefit-icon"><i class="fa-solid fa-paw"></i></div>
          <div>
            <h3>Presenta a tus mascotas</h3>
            <p>Crea perfiles y comparte su historia, fotos y personalidad.</p>
          </div>
        </div>

        <div class="benefit-card">
          <div class="benefit-icon"><i class="fa-solid fa-comments"></i></div>
          <div>
            <h3>Conecta y comparte</h3>
            <p>Habla, organiza paseos y conoce nuevos amigos peludos.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="register-panel register-panel-form">
      <div *ngIf="!registrado">
        <div class="form-header">
          <div class="eyebrow">EMPIEZA GRATIS</div>
          <h2>Crea tu cuenta en iGuau</h2>
          <p>Solo necesitas unos datos para formar parte de la comunidad.</p>
        </div>

        <div class="google-block">
          <div id="google-btn"></div>
        </div>

        <div class="separator"><span>o regístrate con tu correo</span></div>

        <div class="alert alert-danger register-alert" role="alert" aria-live="assertive" *ngIf="error!=''">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span>{{ error }}</span>
        </div>

        <form method="post" class="register-form" novalidate>
          <div class="field-group">
            <label for="username" class="form-label">Correo electrónico</label>
            <div class="input-wrap">
              <i class="fa-solid fa-envelope field-icon"></i>
              <input
                type="email"
                class="form-control"
                placeholder="nombre@ejemplo.com"
                (keypress)="error=''"
                name="username"
                id="username"
                [(ngModel)]="usuario.username"
                autocomplete="email"
                required
              >
            </div>
          </div>

          <div class="field-group">
            <label for="password" class="form-label">Contraseña</label>
            <div class="input-wrap">
              <i class="fa-solid fa-lock field-icon"></i>
              <input
                [type]="showPassword ? 'text' : 'password'"
                class="form-control has-action"
                placeholder="Crea una contraseña segura"
                (keyup.enter)="registro(true)"
                (keypress)="error=''"
                id="password"
                name="password"
                [(ngModel)]="usuario.password"
                autocomplete="new-password"
                required
              >
              <button type="button" class="action-btn" (click)="togglePassword()" aria-label="Mostrar u ocultar contraseña">
                <i class="fa-solid" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <div class="form-hint">
              De 8 a 48 caracteres, con mayúscula, minúscula y número; sin espacios.
            </div>
          </div>

          <div class="field-group">
            <label for="passwordconf" class="form-label">Repite la contraseña</label>
            <div class="input-wrap">
              <i class="fa-solid fa-lock field-icon"></i>
              <input
                [type]="showPasswordConfirm ? 'text' : 'password'"
                class="form-control has-action"
                placeholder="Confirma tu contraseña"
                (keypress)="error=''"
                id="passwordconf"
                name="passwordconf"
                [(ngModel)]="usuario.passwordconf"
                autocomplete="new-password"
                required
              >
              <button type="button" class="action-btn" (click)="togglePasswordConfirm()" aria-label="Mostrar u ocultar confirmación de contraseña">
                <i class="fa-solid" [ngClass]="showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
          </div>

          <div class="checks-block">
            <label class="custom-check">
              <input type="checkbox" value="X" id="mayordeedad" name="mayordeedad" [(ngModel)]="usuario.mayordeedad" (input)="error=''">
              <span class="checkmark"></span>
              <span>Confirmo que soy mayor de 18 años.</span>
            </label>

            <label class="custom-check">
              <input type="checkbox" value="X" id="acepto" name="acepto" [(ngModel)]="usuario.acepto" (input)="error=''">
              <span class="checkmark"></span>
              <span>
                He leído y acepto la
                <a class="pointer" href="{{global.urlServer}}politica-privacidad" target="_blank">política de privacidad</a>
                y el
                <a class="pointer" href="{{global.urlServer}}aviso-legal" target="_blank">aviso legal</a>.
              </span>
            </label>
          </div>

          <div class="submit-block">
            <button class="btn btn-primary submit-btn" type="button" (click)="registro(true)" [disabled]="busy">
              <div class="spinner-border spinner-border-sm" role="status" *ngIf="busy">
                <span class="visually-hidden">Registrando cuenta...</span>
              </div>
              <span *ngIf="busy">Creando tu cuenta...</span>
              <span *ngIf="!busy">Crear mi cuenta gratis <i class="fa-solid fa-arrow-right ms-2"></i></span>
            </button>
          </div>
        </form>

        <div class="login-link-box">
          ¿Ya tienes una cuenta?
          <a href="{{global.urlServer}}login">Inicia sesión</a>
        </div>
      </div>

      <div *ngIf="registrado" class="success-state">
        <div class="eyebrow">TODO LISTO</div>
        <h2>¡Tu cuenta ya está creada!</h2>
        <div class="alert alert-info register-alert" role="status" *ngIf="error">{{ error }}</div>
        <p>
          Estamos encantados de darte la bienvenida. Ahora puedes completar tu perfil y el de tu mascota para empezar a descubrir nuevos contactos, mensajes y momentos compartidos.
        </p>
        <p>
          Si tienes cualquier duda, escríbenos a
          <a href="mailto:info@iguau.es">info&#64;iguau.es</a>.
        </p>
        <a class="btn btn-primary submit-btn" [href]="global.urlServer + 'login'">Ir a iniciar sesión</a>
      </div>
    </div>
  </div>
</div>
